import { render, staticRenderFns } from "./Databank.vue?vue&type=template&id=33c166d6&"
import script from "./Databank.vue?vue&type=script&lang=js&"
export * from "./Databank.vue?vue&type=script&lang=js&"
import style0 from "./Databank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports